import { render, staticRenderFns } from "./cardPie.vue?vue&type=template&id=2f8416b3&scoped=true"
import script from "./cardPie.vue?vue&type=script&lang=js"
export * from "./cardPie.vue?vue&type=script&lang=js"
import style0 from "./cardPie.vue?vue&type=style&index=0&id=2f8416b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8416b3",
  null
  
)

export default component.exports